import Model, { fields } from '@thinknimble/tn-models'

import UserAPI from './api'

export default class User extends Model {
  static api = UserAPI.create(User)

  static id = new fields.CharField({ readOnly: true })
  static email = new fields.CharField({ readOnly: true })
  static token = new fields.CharField()
}
